import { render, staticRenderFns } from "./blog-1.vue?vue&type=template&id=edbd8cd2&scoped=true"
import script from "./blog-1.vue?vue&type=script&lang=js"
export * from "./blog-1.vue?vue&type=script&lang=js"
import style0 from "./blog-1.vue?vue&type=style&index=0&id=edbd8cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbd8cd2",
  null
  
)

export default component.exports